import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';
import { Skeleton } from '@/components/atoms/skeleton';
import { CompanyProfileOverview } from '@/components/organisms/settings-company/CompanyProfileOverview';
import { useCompanySettings } from '@/hooks/settings/useCompanySettings';
import { useHasPermission } from '@/hooks/usePermissions';

export const Route = createFileRoute('/_dashboard/dashboard/settings/company')({
  component: CompanySettingsLayout,
});

function CompanySettingsLayout() {
  const matches = useMatches();
  const isLeaf = matches[matches.length - 1]?.routeId === '/_dashboard/dashboard/settings/company';

  if (!isLeaf) return <Outlet />;

  return <CompanySettingsPage />;
}

function CompanySettingsPage() {
  const { data: company, isLoading } = useCompanySettings();
  const canEdit = useHasPermission('company:edit');

  if (isLoading) {
    return (
      <div className="max-w-5xl space-y-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-32 w-full" />
        <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_360px]">
          <Skeleton className="h-40 w-full" />
          <Skeleton className="h-40 w-full" />
        </div>
      </div>
    );
  }

  if (!company) {
    return (
      <div className="max-w-2xl rounded-lg border bg-background p-6 text-sm text-muted-foreground">
        Company profile is not available.
      </div>
    );
  }

  return <CompanyProfileOverview company={company} canEdit={canEdit} />;
}
